/**
 * Build-time branding configuration.
 * Controlled by VITE_APP_VARIANT env var at build time.
 * Default: 'fleettracko' (no change to existing behavior).
 */

export interface BrandConfig {
  name: string;
  short: string;
  tagline: string;
  version: string;
  colors: {
    primary: Record<string, string>;
  };
}

const version = import.meta.env.VITE_APP_VERSION || '0.0.0-dev';

const brands: Record<string, BrandConfig> = {
  fleettracko: {
    name: 'FleetTracko',
    short: 'FT',
    tagline: 'Fleet Management',
    version,
    colors: {
      primary: {
        50: '#eff6ff',
        100: '#dbeafe',
        200: '#bfdbfe',
        300: '#93c5fd',
        400: '#60a5fa',
        500: '#3b82f6',
        600: '#2563eb',
        700: '#1d4ed8',
        800: '#1e40af',
        900: '#1e3a8a',
        950: '#172554',
      },
    },
  },
  apleona: {
    name: 'Apleona',
    short: 'AP',
    tagline: 'Fuhrparkmanagement',
    version,
    colors: {
      primary: {
        50: '#effef7',
        100: '#d9fbeb',
        200: '#b5f5d8',
        300: '#7aeabc',
        400: '#3dd69a',
        500: '#1dbd7e',
        600: '#109964',
        700: '#0f7a53',
        800: '#106043',
        900: '#0e4f38',
        950: '#00594C',
      },
    },
  },
  hubmotion: {
    name: 'Hubmotion',
    short: 'HM',
    tagline: 'Compound Operations',
    version,
    colors: {
      primary: {
        50: '#fafff0',
        100: '#f3ffd6',
        200: '#e6ffac',
        300: '#d5ff7d',
        400: '#c8ff57',
        500: '#b3e635',
        600: '#94c019',
        700: '#6f9111',
        800: '#557010',
        900: '#485f12',
        950: '#263305',
      },
    },
  },
};

const variant = (import.meta.env.VITE_APP_VARIANT as string) || 'fleettracko';

export const branding: BrandConfig = brands[variant] || brands.fleettracko;
